export default {
      id: "ic_twitter-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_twitter-usage",
      toString: function () {
        return this.url;
      }
    }